<template>
    <div class="avatar-upload">
        <div class="avatar-preview">
            <img
                class="avatar-icon"
                id="pick-avatar"
                :src="avatar"
                ref="avatarPreview" />
            <avatar-cropper
                @uploaded="handleUploaded"
                @error="handleError"
                @uploading="handleUploading"
                trigger="#pick-avatar"
                upload-url="/profile/uploadavatar"
                :labels="labels" />
        </div>

        <div class="actions">
            <b-button
                class="btn-upload btn-avatar-upload"
                variant="primary"
                @click="$refs.avatarPreview.click()">
                {{ $t('user_account.upload_photo') }}
            </b-button>
        </div>
    </div>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';

export default {
    name: 'design-2021-user-avatar-upload-component',
    props: {
        userIn: Object,
    },
    components: { AvatarCropper },
    data() {
        return {
            labels: { submit: this.$t('common.save'), cancel: this.$t('common.cancel') },
            cropperOptions: { aspectRatio: NaN },
            avatar: this.userIn.profile_image_thumb_path
                ? this.userIn.profile_image_thumb_path
                : '/default_avatar_profile.jpg',
        };
    },
    methods: {
        handleUploaded(resp) {
            this.avatar = resp.image.file.path;
            this.alert.success(this.$t('user_account.photo_saved_title'), this.$t('user_account.photo_saved_body'));
        },
        handleError(resp) {
            this.alert.ajaxError(error);
        },
        handleUploading() {
            this.alert.saving(this.$t('user_account.save_photo_title'), this.$t('user_account.save_photo_body'));
        },
    },
};
</script>

<style scoped lang="scss">
.avatar-upload {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

    .avatar-preview {
        display: flex;
        justify-content: center;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        img {
            height: auto;
            width: 200px;
            border-radius: $border-radius-content;
        }
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .avatar-upload {
        margin-bottom: 0;

        .avatar-preview {
            img {
                width: 100%;
                max-width: 200px;
            }
        }
    }
}
</style>
